"use client";
import React from 'react';
import './FormStep3.css';
import PropTypes from 'prop-types';
import { Input, Select } from 'atm-global-stylish/dist';
import PhoneInput from '../basic/PhoneInput/PhoneInput';
import { useEffect, useState } from 'react';
import useSiniestrosStore from '../../store/siniestrosStore';
import { isEmpty, showModal } from '../../utils/functions';
import { DEFAULT_MODEL_LIST, INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../config/constants';


const VehicleStep3 = ({ errors, isOwner, formData, handleChange, type, options_rodado, options_companies }) => {
	const { getMarcas, getModelos } = useSiniestrosStore();
	const [marcasList, setMarcasList] = useState([{ value: "", title: "Seleccioná una marca *" }]);
	const [modelosList, setModelosList] = useState(DEFAULT_MODEL_LIST);
	const [brand, setBrand] = useState('');
	const [model, setModel] = useState('');
	const [subModel, setSubModel] = useState('');
	const [year, setYear] = useState('');

	const [clicked, setClicked] = useState(false);
	const [showModelManual, setShowModelManual] = useState(false);

	useEffect(() => {
		if (!isEmpty(formData.owner_vehicle_brand)) {
			if (!isEmpty(brand) && brand !== formData.owner_vehicle_brand) {
				setModelosList(DEFAULT_MODEL_LIST);
				handleChange('owner_vehicle_model')({ target: { value: '' } });
				handleChange('owner_vehicle_sub_model')({ target: { value: '' } });
				handleChange('owner_vehicle_model_name')({ target: { value: '' } });
				setModel('');
				setSubModel('');
			}
			setBrand(formData.owner_vehicle_brand);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formData.owner_vehicle_brand]);

	useEffect(() => {
		if (marcasList.length > 1 && !isEmpty(formData.owner_vehicle_model)) {
			// Esto se hace para que cuando se cargue la lista de marca y los modelos ya esten cargados, se pueda seleccionar el valor correspondiente del modelo
			setModel(formData.owner_vehicle_model);
			setSubModel(formData.owner_vehicle_sub_model)
		}

		// eslint-disable-next-line eqeqeq
		if (formData.owner_vehicle_model == '-1') {
			setShowModelManual(true);
		} else {
			setShowModelManual(false);
		}
	}, [marcasList, formData.owner_vehicle_model, formData.owner_vehicle_sub_model]);

	const cleanFields = () => {
		setMarcasList([{ value: "", title: "Seleccioná una marca *" }]);
		handleChange('owner_vehicle_brand')({ target: { value: '' } });
		handleChange('owner_vehicle_brand_name')({ target: { value: '' } });
		setBrand('');

		setModelosList(DEFAULT_MODEL_LIST);
		handleChange('owner_vehicle_model')({ target: { value: '' } });
		handleChange('owner_vehicle_sub_model')({ target: { value: '' } });
		handleChange('owner_vehicle_model_name')({ target: { value: '' } });
		setModel('');
		setSubModel('');
	}

	const fetchMarcas = async () => {
		const formDataYear = formData?.owner_vehicle_year;

		const branch = (((type === '2') && '3') || ((type === '3') && '4'))
		if (formDataYear.length === 4) {
			setYear(formDataYear);

			if (!isEmpty(year) && year !== formDataYear) {
				// Esto significa que los anios no son los mismos, el anio cambio entonces tengo que limpiar la lista de marcas, modelos y vacias los campos de modelo y marcas
				cleanFields();
			}

			try {
				const responseMarcas = await getMarcas(branch, formDataYear);

				if (!isEmpty(responseMarcas.response)) {
					setMarcasList([
						{ value: "", title: "Seleccioná una marca *" },
						...responseMarcas.response.map((item) => ({
							value: item.MarCod,
							title: item.MarDsc
						}))
					]);
				} else {
					setMarcasList(null);
					handleChange('owner_vehicle_brand')({ target: { value: '' } });
					handleChange('owner_vehicle_model')({ target: { value: '' } });
					handleChange('owner_vehicle_sub_model')({ target: { value: '' } });
					setBrand('');
					setModel('');
					setSubModel('');
				}
			} catch (err) {
				console.error("Error al obtener marcas:", err);
				cleanFields();
			}
		} else {
			cleanFields();
		}
	}

	useEffect(() => {
		if (type !== '1') {
			(async () => {
				await fetchMarcas();
			})();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [type, formData?.owner_vehicle_year]);

	const fetchModelos = async (p = null) => {
		const b = p === null ? formData?.owner_vehicle_brand : p;

		const year = formData?.owner_vehicle_year;
		if (year.length === 4 && (b !== '') && (marcasList !== null)) {
			try {
				await getModelos(b, year).then(data => {
					if (!isEmpty(data?.response)) {
						setModelosList([
							{ value: "", title: "Seleccioná un modelo *" },
							{ value: "-1", title: "OTRO" },
							...data.response.map((item) => ({
								value: item.VehCodMod,
								title: item.VehModDsc,
								extra_value: item.VehCodSubMod
							}))
						]);
					}
				})
			} catch (err) {
				console.error("Error al obtener marcas:", err);
			}
		} else {
			if (marcasList === null) {
				setModelosList(null);
				handleChange('owner_vehicle_model')({ target: { value: '' } })
				handleChange('owner_vehicle_sub_model')({ target: { value: '' } })
			}
		}
	}

	useEffect(() => {
		if (type !== '1') {
			(async () => {
				await fetchModelos();
			})();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [type, formData?.owner_vehicle_brand]);

	useEffect(() => {
		if (!isEmpty(modelosList) && modelosList.length > 1 && !isEmpty(formData.owner_vehicle_model)) {
			setModel(formData.owner_vehicle_model);
			setSubModel(formData.owner_vehicle_sub_model);
		}
	}, [formData.owner_vehicle_model, formData.owner_vehicle_sub_model, modelosList]);

	const changeLicence = (e) => {
		e.target.value = e.target.value.toUpperCase();
		handleChange('owner_vehicle_plate')(e);
	}

	const handleChangeBrand = (e) => {
		let selected = {
			value: '',
			title: ''
		}
		if (marcasList.length > 1) {
			selected = marcasList?.find(item => parseInt(item.value) === parseInt(e.target.value));
		}

		handleChange('owner_vehicle_brand')({ target: { value: selected?.value || '' } });
		handleChange('owner_vehicle_brand_name')({ target: { value: selected?.title || '' } });
	}

	const handleChangeModel = (e) => {
		let selected = {
			value: '',
			title: ''
		}

		if (marcasList.length > 1) {
			selected = modelosList?.find(item => parseInt(item.value) === parseInt(e.target.value));
		}

		handleChange('owner_vehicle_model')({ target: { value: selected?.value || '' } });
		handleChange('owner_vehicle_sub_model')({ target: { value: selected.extra_value !== undefined ? selected.extra_value : '' } });

		// eslint-disable-next-line eqeqeq
		if (e.target.value != '-1')
			handleChange('owner_vehicle_model_name')({ target: { value: selected?.title || '' } });
	}

	return (
		<div className='formstep3'>
			{isOwner === '1' ? (
				<>
				</>
			) : (
				<>
					<h2 className='text-xl text-red font-semibold my-4 w-full text-center'>Datos personales del dueño del {type === '1' ? 'rodado' : 'vehículo'}</h2>
					<div className='w-full flex flex-col gap-5 my-4'>
						<div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
							<Input type='text' value={formData.owner_vehicle_name} handleChange={handleChange('owner_vehicle_name')} placeholder='Nombre y Apellido / RAZON SOCIAL' className={`${!errors.owner_vehicle_name ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
							<Input
								type='number'
								value={formData.owner_vehicle_cuit}
								maxLength={11}
								handleChange={(e) => {
									const onlyNumbers = e.target.value.replace(/\D/g, '');

									if (onlyNumbers.length <= 11)
										handleChange('owner_vehicle_cuit')({ target: { value: onlyNumbers } })
									else
										return
								}}
								placeholder='CUIT / CUIL / DNI'
								className={`${!errors.owner_vehicle_cuit ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
							/>
						</div>
						<div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
							<Input type='text' value={formData.owner_vehicle_address} handleChange={handleChange('owner_vehicle_address')} placeholder='Domicilio' className={`${!errors.owner_vehicle_address ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
							<PhoneInput
								handleChange={handleChange}
								value={formData.owner_vehicle_phone}
								prefix={'owner_vehicle_'}
								className={`${!errors.owner_vehicle_phone ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
							/>
						</div>
						<div className='flex flex-row w-full justify-between gap-10'>
							<Input type='email' value={formData.owner_vehicle_mail} handleChange={handleChange('owner_vehicle_mail')} placeholder='Correo Electronico' className={`${!errors.owner_vehicle_mail ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={100} regex={/^[a-zA-Z0-9@._\-,]*$/} />
						</div>
					</div>
				</>
			)}
			{
				isOwner === '1' && (<h2 className='text-xl text-red font-semibold my-4 w-full text-center'>Los datos de tu {type === '1' ? 'rodado' : 'vehículo'}</h2>)
			}
			<div className={`w-full flex flex-col gap-5 my-4 ${isOwner !== '1' && 'mt-5'}`}>
				<div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
					{type === '1' ?
						<Select
							list={options_rodado}
							onChange={handleChange('things_code')}
							selectedValue={String(formData.things_code) || ''}
							className={`${!errors.things_code ? 'text-grey-tx' : 'text-shiny-pink'} ${SELECT_CLASSNAME}`}
						/>
						:
						<Input type='text' value={formData.owner_vehicle_plate} handleChange={changeLicence} placeholder='Patente' className={`${!errors.owner_vehicle_plate ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={7} regex={/^[a-zA-Z0-9]*$/} />
					}
					<Input 
						type='number'
						value={formData.owner_vehicle_year}
						handleChange={(e) => {
							const onlyNumbers = e.target.value.replace(/\D/g, '');

							if (onlyNumbers.length <= 4)
								handleChange('owner_vehicle_year')({ target: { value: onlyNumbers } })
							else
								return
						}}
						placeholder='Año'
						className={`${!errors.owner_vehicle_year ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
						maxLength={4}
					/>
				</div>
				<div className={`grid grid-cols-1 md:grid-cols-${showModelManual === true ? '3' : '2'} w-full justify-between gap-5 md:gap-10`}>
					{(marcasList && type !== '1') ?
						<Select
							list={marcasList}
							onChange={(e) => handleChangeBrand(e)}
							selectedValue={brand}
							className={`${!errors.owner_vehicle_brand ? 'text-grey-tx' : 'text-shiny-pink'} ${SELECT_CLASSNAME}`}
							dataSearch={true}
							inputSearchHidden={false}
						/>
						:
						<Input type='text' value={formData.owner_vehicle_brand} handleChange={handleChange('owner_vehicle_brand')} placeholder='Marca' className={`${!errors.owner_vehicle_brand ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={30} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					}
					{(modelosList && type !== '1') ?
						<div className="flex w-full" onClick={async () => {
							if (clicked === false && !isEmpty(brand)) {
								setClicked(true);
								handleChange('owner_vehicle_model_name')({ target: { value: '' } });
								// await showModal('', 'En el caso de que no encuentres un modelo en el listado, podés ingresarlo manualmente seleccionando la opción "OTRO"');
							}
						}}>
							<Select
								list={modelosList}
								onChange={(e) => handleChangeModel(e)}
								selectedValue={model}
								className={`${!errors.owner_vehicle_model ? 'text-grey-tx' : 'text-shiny-pink'} ${SELECT_CLASSNAME}`}
								dataSearch={true}
								inputSearchHidden={false}
							/>
						</div>
						:
						<Input type='text' value={formData.owner_vehicle_model} handleChange={handleChange('owner_vehicle_model')} placeholder='Modelo' className={`${!errors.owner_vehicle_model ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={30} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					}
					{
						showModelManual === true ?
							<Input
								type='text'
								value={formData.owner_vehicle_model_name}
								handleChange={handleChange('owner_vehicle_model_name')}
								placeholder='Modelo *'
								className={`${!errors.owner_vehicle_model_name ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
								maxLength={100}
								regex={/^[a-zA-Z0-9 @.\-,]*$/}
							/>
							:
							<></>
					}
				</div>
				<div className='flex flex-col w-full my-5 md:my-4'>
					{type === '1' ?
						<textarea
							className={`border-2 border-pink rounded-lg p-3 w-full h-40 resize-none focus:outline-none ${INPUT_CLASSNAME} ${!errors.things_text ? 'input' : 'incomplete'}`}
							placeholder="Describí los daños..."
							onChange={handleChange('things_text')}
							value={formData.things_text}
							maxLength={240}
						/>
						:
						<textarea
							className={`border-2 border-pink rounded-lg p-3 w-full h-40 resize-none focus:outline-none ${INPUT_CLASSNAME} ${!errors.owner_vehicle_damage ? 'input' : 'incomplete'}`}
							placeholder="Describí los daños..."
							onChange={handleChange('owner_vehicle_damage')}
							value={formData.owner_vehicle_damage}
							maxLength={240}
						/>

					}
				</div>

				<div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
					<Select
						list={options_companies}
						onChange={handleChange('owner_vehicle_insurance_company')}
						selectedValue={String(formData.owner_vehicle_insurance_company) || ''}
						className={`${!errors.owner_vehicle_insurance_company ? 'text-grey-tx' : 'text-shiny-pink'} ${SELECT_CLASSNAME}`}
						dataSearch
						inputSearchHidden={false}
					/>
					<Input
						type='number'
						value={formData.owner_vehicle_insurance_number}
						handleChange={(e) => {
                    		const onlyNumbers = e.target.value.replace(/\D/g, '');

							if (onlyNumbers.length <= 8)
								handleChange('owner_vehicle_insurance_number')({ target: { value: onlyNumbers } })
							else
								return
						}}
						placeholder='Número de póliza (opcional)'
						className={`${!errors.owner_vehicle_insurance_number ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
						maxLength={8}
					/>
				</div>
			</div>
			{Object.keys(errors).length > 0 && (
				<p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
			)}
		</div>
	);
};

VehicleStep3.propTypes = {
	errors: PropTypes.object,
	isOwner: PropTypes.string,
	formData: PropTypes.object,
	handleChange: PropTypes.func
};

export default VehicleStep3;